// Packages
import _ from 'lodash';

export default {
    /**
     * Ensure the paramString's length is divisible by 4, this is a common way to check to see if a string is base64 encoded.
     * Then check against a nasty regex pattern to ensure the paramString matches base64 conventions.
     * Reference material: https://stackoverflow.com/questions/8571501/how-to-check-whether-the-string-is-base64-encoded-or-not
     * @returns { Boolean }
     * @param paramString
     */
    isValidBase64String( paramString ) {
        return ( paramString.length > 0 )
            && ( paramString.length % 4 === 0 )
            && ( /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/.test( paramString ) );
    },

    /**
     * Ensure a given array has items
     * You check for this kind of junk a lot of in js, so might as well have it in once place
     * @returns { Boolean }
     */
    arrayHasItems: ( array ) => ( !!array && !!array.length && ( array.length > 0 ) ),
    required: ( item ) => !!item,
    requiredObject: ( item ) => !_.isEmpty( item ),
};
